// src/aws-config.js
import { LexRuntimeV2Client } from "@aws-sdk/client-lex-runtime-v2";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

const REGION = process.env.REACT_APP_AWS_REGION || "us-east-1";
const IDENTITY_POOL_ID = process.env.REACT_APP_IDENTITY_POOL_ID;

export const lexRuntime = new LexRuntimeV2Client({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: IDENTITY_POOL_ID,
  }),
});
